var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpatheticMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.656,
    height: 6.677,
    viewBox: "0 0 7.656 6.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart",
    transform: "translate(-12.288 -22.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161840",
    "data-name": "Group 161840",
    transform: "translate(12.288 22.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83763",
    "data-name": "Path 83763",
    d: "M16.12,23.979l-.4-.4a2.012,2.012,0,1,0-2.845,2.845l3.234,3.234h0l.01.01,3.234-3.234a2.012,2.012,0,1,0-2.845-2.845Zm-.009,4.646,1.806-1.806.53-.512h0l.389-.389a1.28,1.28,0,1,0-1.811-1.811l-.906.906,0,0h0l-.912-.912a1.28,1.28,0,1,0-1.811,1.811l.929.929h0l1.787,1.787Z",
    transform: "translate(-12.288 -22.992)",
    fill: "#ff0062",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpatheticMessageIcon);
export default __webpack_public_path__ + "static/media/empathetic-message-icon.14607ca21c43f8ab45c1a80a1dfbb48c.svg";
export { ForwardRef as ReactComponent };